
<script lang="ts" setup>
    import DContainer from "../atoms/DContainer.vue";

    import {onMounted, onUnmounted} from "vue";

    defineProps<{
        variant?: "full" | "minimal" | "default";
    }>();

    onMounted(() => {
        document.documentElement.style.overflow = "hidden";
        document.body.style.overflow = "hidden";
    });

    onUnmounted(() => {
        document.documentElement.style.overflow = "auto";
        document.body.style.overflow = "auto";
    });
</script>

<template>
    <Teleport to="body">
        <DContainer class="d-overlay" :class="variant ? `d-overlay-${variant}` : ''" v-bind="$attrs">
            <slot/>
        </DContainer>
    </Teleport>
</template>

<style lang="scss" scoped>
.d-overlay {
  position: fixed;
  display: grid;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100dvh;
  z-index: var(--z-index-modal);
  background: rgba(0, 0, 0, 0.5);

    @include md {
        height: 100vh;
    }

    &.d-overlay-minimal {
        height: 100vh;
    }
}

</style>